module.exports = __webpack_public_path__ + "static/img/GB.ad3c5690.svg";